import { COLORS } from "../../theme/colors";

export const PERIODS = [
  {
    name: "YTD",
    filter: "ytd",
    show: true,
  },
  {
    name: "Acc.",
    filter: "acc",
    show: true,
  },
  {
    name: "20Y",
    filter: "20y",
    show: true,
  },
  {
    name: "RANGE",
    filter: undefined,
    show: false,
  },
];

export const DATE_PART_PERIODS = [
  {
    name: "H",
    filter: "hour",
    show: true,
  },
  {
    name: "D",
    filter: "day",
    show: true,
  },
  {
    name: "M",
    filter: "month",
    show: true,
  },
  {
    name: "Q",
    filter: "quarter",
    show: true,
  },
  {
    name: "Y",
    filter: "year",
    show: true,
  },
];

export const GRAPH_UNITS = {
  kwh: "kWh",
  tonCarbon: "tCO2",
  nFormatter: "nFormatter",
};

export const KPIS = {
  power_revenue: 0,
  emission_reduction: 1,
  noi_increase: 2,
  unrealized_power_revenue: 3,
};

export const MAP_TABS = [
  "Tenancy Management",
  "Leasing Opportunities",
  "Emission Impact",
  "New Power Assets",
  "Buildings Maintenance",
];

export const MAP_TAB_KEYS = {
  tenancy_management: 0,
  leasing_opportunities: 1,
  emission_impact: 2,
  new_power_assets: 3,
  buildings_maintenance: 4,
};

export const BUILDING_STATUS = {
  VACANCY_RATE: "VACANCY_RATE",
  UNCONNECTED_TENANTS: "UNCONNECTED_TENANTS",
  RISKY_TENANTS: "RISKY_TENANTS",
  SHORT_TENANCY_AVG: "SHORT_TENANCY_AVG",
  EXPECTED_GROWTH: "EXPECTED_GROWTH",
  DECREASING_CONSUMPTION: "DECREASING_CONSUMPTION",
  SUSPICIOUS_USAGE_IN_PREMISES: "SUSPICIOUS_USAGE_IN_PREMISES",
  HIGHEST_CARBON_REDUCTION: "HIGHEST_CARBON_REDUCTION",
  HIGHEST_CARBON_REDUCTION_POTENTIAL: "HIGHEST_CARBON_REDUCTION_POTENTIAL",
  LOWEST_CARBON_REDUCTION: "LOWEST_CARBON_REDUCTION",
  BEST_FIT_FOR_SOLAR: "BEST_FIT_FOR_SOLAR",
  BEST_FIT_FOR_BATTERY: "BEST_FIT_FOR_BATTERY",
  BEST_FIT_FOR_EV: "BEST_FIT_FOR_EV",
  MAINTENANCE_ALERTS: "MAINTENANCE_ALERTS",
  APPLIANCES_IN_RISK: "APPLIANCES_IN_RISK",
  MAINTENANCE_REQUESTED: "MAINTENANCE_REQUESTED",
  INEFFICIENT_APPLIANCE: "INEFFICIENT_APPLIANCE",
  OTHER_BUILDING: "",
};

export const MAP_ICON_COLORS = {
  [BUILDING_STATUS.VACANCY_RATE]: COLORS.red,
  [BUILDING_STATUS.UNCONNECTED_TENANTS]: COLORS.purple,
  [BUILDING_STATUS.RISKY_TENANTS]: "#6699FF",
  [BUILDING_STATUS.SHORT_TENANCY_AVG]: "#CC7700",
  [BUILDING_STATUS.EXPECTED_GROWTH]: COLORS.green,
  [BUILDING_STATUS.DECREASING_CONSUMPTION]: COLORS.red,
  [BUILDING_STATUS.SUSPICIOUS_USAGE_IN_PREMISES]: COLORS.purple,
  [BUILDING_STATUS.HIGHEST_CARBON_REDUCTION]: COLORS.green,
  [BUILDING_STATUS.HIGHEST_CARBON_REDUCTION_POTENTIAL]: COLORS.purple,
  [BUILDING_STATUS.LOWEST_CARBON_REDUCTION]: COLORS.red,
  [BUILDING_STATUS.BEST_FIT_FOR_SOLAR]: COLORS.lightYellow,
  [BUILDING_STATUS.BEST_FIT_FOR_BATTERY]: COLORS.majorelleBlue,
  [BUILDING_STATUS.BEST_FIT_FOR_EV]: "#63B9C4",
  [BUILDING_STATUS.MAINTENANCE_ALERTS]: COLORS.red,
  [BUILDING_STATUS.APPLIANCES_IN_RISK]: COLORS.orange,
  [BUILDING_STATUS.MAINTENANCE_REQUESTED]: COLORS.purple,
  [BUILDING_STATUS.INEFFICIENT_APPLIANCE]: "#C5C5C5",
};

export const MAP_LEGENDS = [
  [
    {
      text: "Vacancy rate",
      status: BUILDING_STATUS.VACANCY_RATE,
    },
    {
      text: "Unconnected tenants",
      status: BUILDING_STATUS.UNCONNECTED_TENANTS,
    },
    {
      text: "Risky tenants",
      status: BUILDING_STATUS.RISKY_TENANTS,
    },
    {
      text: "Short tenancy avg.",
      status: BUILDING_STATUS.SHORT_TENANCY_AVG,
    },
    { text: "Other buildings", status: BUILDING_STATUS.OTHER_BUILDING },
  ],
  [
    {
      text: "Expected growth",
      status: BUILDING_STATUS.EXPECTED_GROWTH,
    },
    {
      text: "Decreasing consumption",
      status: BUILDING_STATUS.DECREASING_CONSUMPTION,
    },
    {
      text: "Suspicious usage in premises",
      status: BUILDING_STATUS.SUSPICIOUS_USAGE_IN_PREMISES,
    },
    { text: "Other buildings", status: BUILDING_STATUS.OTHER_BUILDING },
  ],
  [
    {
      text: "Highest carbon reduction",
      status: BUILDING_STATUS.HIGHEST_CARBON_REDUCTION,
    },
    {
      text: "Highest carbon reduction potential",
      status: BUILDING_STATUS.HIGHEST_CARBON_REDUCTION_POTENTIAL,
    },
    {
      text: "Lowest carbon reduction",
      status: BUILDING_STATUS.LOWEST_CARBON_REDUCTION,
    },
    { text: "Other buildings", status: BUILDING_STATUS.OTHER_BUILDING },
  ],
  [
    {
      text: "Best fit for solar",
      status: BUILDING_STATUS.BEST_FIT_FOR_SOLAR,
    },
    {
      text: "Best fit for battery",
      status: BUILDING_STATUS.BEST_FIT_FOR_BATTERY,
    },
    {
      text: "Best fit for EV",
      status: BUILDING_STATUS.BEST_FIT_FOR_EV,
    },
    { text: "Other buildings", status: BUILDING_STATUS.OTHER_BUILDING },
  ],
  [
    {
      text: "Maintenance alerts",
      status: BUILDING_STATUS.MAINTENANCE_ALERTS,
    },
    {
      text: "Appliances at risk",
      status: BUILDING_STATUS.APPLIANCES_IN_RISK,
    },
    {
      text: "Maintenance requested",
      status: BUILDING_STATUS.MAINTENANCE_REQUESTED,
    },
    {
      text: "Inefficient appliances",
      status: BUILDING_STATUS.INEFFICIENT_APPLIANCE,
    },
    { text: "Other buildings", status: BUILDING_STATUS.OTHER_BUILDING },
  ],
];

export const CHART_KEYS = {
  trading: "trading",
  battery: "battery",
  ev: "ev",
  consumption: "consumption",
  target: "target",
  allowance: "allowance",
  power_revenue: "power_revenue",
  unrealized_trading: "unrealized_trading",
  unrealized_power_asset: "unrealized_power_asset",
  total_unrealized: "total_unrealized",
  noi_with_power_revenue: "noi_with_power_revenue",
};

export const BAR_CHART_COLORS = {
  trading: COLORS.purple,
  battery: "#4F31CF",
  ev: COLORS.cian,
  consumption: COLORS.purple,
  target: "#4F31CF",
  allowance: COLORS.cian,
  power_revenue: COLORS.purple,
  unrealized_trading: "#E5D0B0",
  unrealized_power_asset: "#FFA030",
  total_unrealized: "#FC0404",
  allowances_trading: "#349E88",
  voluntery_credits: "#A2F8A9",
  offset_credits: "#4EE3C5",
  noi_with_power_revenue: COLORS.yellow,
};

export const UNREALIZED_SHIFT_BARS = [
  { dataKey: "unrealized_trading", fill: BAR_CHART_COLORS.unrealized_trading },
  { dataKey: "unrealized_power_assets", fill: BAR_CHART_COLORS.unrealized_power_asset },
  { dataKey: "power_revenues", fill: BAR_CHART_COLORS.power_revenue},
  { dataKey: "total_unrealized", fill: BAR_CHART_COLORS.total_unrealized },
];
